import Network from 'PREPAREsrc/service/Network';
import API from 'PREPAREsrc/service/api';
import LegacyPratusTable from 'components/DesignSystems/PratusTable/LegacyPratusTable';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { endLoading, startLoading } from 'reducers/loading/loading.action';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import { useExerciseBasePath } from 'utils/useExerciseBasePath';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

dayjs.extend(relativeTime);

export default function PrepareLog() {
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();

  const { selectedWorkspace } = useSelector((state) => state.prepare.workspace);
  const lastWorkspaceId = useSelector(
    (state) => state.app.user.epic_user_lastWorkspaceId
  );
  const exerciseBasePath = useExerciseBasePath();

  const [prepareActivityLogs, setPrepareActivityLogs] = useState([]);

  const activityLogList = () => {
    reduxDispatch(startLoading());
    try {
      Network.get(API.allActivityLogList, {
        workspaceId: selectedWorkspace || lastWorkspaceId,
      })
        .then((resp) => {
          setPrepareActivityLogs(
            resp.data.response.dataset.map((element) => {
              return {
                ...element,
                injectname:
                  (element.number ? `#${element.number} - ` : '') +
                  (element.injectname || ''),

                createdAt: dayjs(element.createdAt).fromNow(),
              };
            })
          );
        })

        .catch(console.log)
        .finally(() => {
          reduxDispatch(endLoading());
        });
    } catch (error) {
      toast.error(error?.response?.data?.response?.status?.msg);
    }
  };

  const dataColPrepare = [
    {
      dataField: 'username',
      text: 'Name',
      sort: true,
      headerAttrs: { title: 'Sort By:' },
      attrs: { title: 'User' },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center">
            <div className="me-2 flex-shrink-0 button--icon primary rounded-circle p-0">
              <span className="weight-600 txt--sml">
                {row.username?.charAt(0)?.toUpperCase()}
              </span>
            </div>
            <p className="mb-0">{row.username}</p>
          </div>
        );
      },
    },

    {
      dataField: 'type',
      text: 'Type',
      sort: true,
      attrs: { title: 'Type' },
      formatter: (cell, row) => {
        return (
          <>
            {row.type === 'updatePlanInject'
              ? 'Update Plan Inject'
              : row.type === 'comment'
                ? 'Comment'
                : null}
          </>
        );
      },
    },
    {
      dataField: 'injectname',
      text: 'Inject Name',
      sort: true,
      attrs: { title: 'InjectName' },
      formatter: (cell, row) => {
        return (
          <>
            <StylishNewButton
              className="button button--link cursor-pointer"
              onClick={() => {
                navigate(`${exerciseBasePath}/msel-view/${row.injectId}`, {
                  replace: true,
                });
              }}
            >
              {row.injectname}
            </StylishNewButton>
          </>
        );
      },
    },

    {
      dataField: 'createdAt',
      text: 'Time',
      sort: true,
      attrs: { title: 'Time' },
    },
  ];

  const expandRow = {
    parentClassName: 'parent-expand-tr',
    className: 'child-expand-tr',
    renderer: (row) => {
      const clean = sanitizeHtml(row.content);
      return (
        <>
          <div className="row">
            <label className="form-label d-block">Comment</label>
            <div
              className="m-0"
              dangerouslySetInnerHTML={{ __html: clean }}
            ></div>
          </div>
        </>
      );
    },
    showExpandColumn: true,
    onlyOneExpanding: true,
    nonExpandable: prepareActivityLogs
      ?.filter((item) => item.type !== 'comment')
      ?.map((item) => item.logid),
  };

  useEffect(() => {
    activityLogList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LegacyPratusTable
        keyField={'logid'}
        columns={dataColPrepare}
        rows={prepareActivityLogs}
        expandRow={expandRow}
        hasPagination={true}
        paginationPerPageItem="10"
      />
    </>
  );
}
